import React, { Component } from 'react';
import { Grid, Card, Image, Input, Button, Form, TextArea, Dropdown } from 'semantic-ui-react';
import Server from '../../../functions/server'
import $ from "jquery";
import Loading from '../../loading';
import Dialogmessage from '../../dialog';
import Editicon from '../../media/icon.png';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class Edit extends Component {

  state = {
    load: false,
    message: '',
    error: '',
    file: Editicon,
    dialogmessage: '',
    dialogstatus: '',
    title: '',
    description: '',
    long_description: '',
    tamil_name: '',
    local_name: '',
  }

  componentDidMount() {
    this.setValuesToState(this.props);
  }

  componentWillReceiveProps(props) {
      this.setValuesToState(props);
  }

  setValuesToState(props) {
    let data = props.data;
    this.setState({
      title: data.title,
      description: data.description,
      long_description: data.long_description,
      tamil_name: data.tamil_name,
      local_name: data.local_name,
      status: data.status,
    })
  }

  updateInfo() {
    let context = this;
    let partno = this.props.partno;
    let title = this.state.title;
    let description = this.state.description;
    let long_description = this.state.long_description;
    let tamil_name = this.state.tamil_name;
    let local_name = this.state.local_name;
    let status = this.state.status;
    if (title == '' || title == null || title == undefined) {
      context.setState({ error: 'Enter title!!!' })
      return;
    }
    if (description == '' || description == null || description == undefined) {
      context.setState({ error: 'Enter description!!!' })
      return;
    }
    if (long_description == '' || long_description == null || long_description == undefined) {
      context.setState({ error: 'Enter long description!!!' })
      return;
    }
    if (tamil_name == '' || tamil_name == null || tamil_name == undefined) {
      context.setState({ error: 'Enter Tamil name!!!' })
      return;
    }
    if (local_name == '' || local_name == null || local_name == undefined) {
      context.setState({ error: 'Enter Local name!!!' })
      return;
    }
    context.setState({
      load: true,
      message: 'Spare Information editing!!!'
    });
    let data1 = {'partno': partno, 'title': title, 'description': description, 'longDescription': long_description,
                  'localName': local_name, 'tamilName': tamil_name, 'status': status };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/updateinfo.php',
      success: function(data) {
        console.log(data);
        if (data == 1) {
          context.setState({
            load:  false,
            dialogmessage: 'Your spare part is edited successfully!!!',
            dialogstatus: true,
          });
        }
        else {
          context.setState({
            load: false,
          });
          alert('Try again');
        }
      },
      error: function(err) {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  onChange = (type) => (e, {value}) => {
    this.setState({
      [type]: value
    })
  }

  closedialog() {
    this.setState({
      dialogstatus: false
    })
  }

  status = (f, { value }) => {
    this.setState({ status: value });
  }

  render() {
    let status = [
      { key: 'Active', text: 'Active', value: 'Active' },
      { key: 'Inactive', text: 'Inactive', value: 'Inactive' },
    ];
    let { load, message, dialogmessage, dialogstatus } = this.state;
    let loading, dialogs;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    if (dialogstatus) {
      dialogs = (<Dialogmessage message={dialogmessage} closedialog={this.closedialog.bind(this)} dialogstatus={dialogstatus} />)
    }
    let out = (
        <div>
          <Card fluid>
          <Grid style={{padding: '1%'}}>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  Title<br/>
                  <Input id='title' focus value={this.state.title}
                      onChange={this.onChange('title')}
                      placeholder='Title' style={{ borderColor: '#5A9CBB' }}
                      fluid />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  Description<br/>
                  <Form>
                    <TextArea id='description' value={this.state.description}
                        autoHeight placeholder='Description' fluid
                        onChange={this.onChange('description')}
                        style={{ minHeight: 100, borderColor: '#5A9CBB' }} />
                  </Form>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  Long Description<br/>
                  <Form>
                    <TextArea id='longDescription'
                        value={this.state.long_description} autoHeight
                        placeholder='Local Description' fluid
                        onChange={this.onChange('long_description')}
                        style={{ minHeight: 100, borderColor: '#5A9CBB' }} />
                  </Form>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={6}>
                  Tamil Name<br/>
                  <Input focus id='tamilName' value={this.state.tamil_name}
                        onChange={this.onChange('tamil_name')}
                        placeholder='Tamil Name'
                        style={{ borderColor: '#5A9CBB' }} fluid />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={6}>
                  Local Name<br/>
                  <Input focus id='localName'
                    onChange={this.onChange('local_name')}
                    value={this.state.local_name}
                    placeholder='Local Name'
                    style={{ borderColor: '#5A9CBB' }} fluid />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={4}>
                  Status<br/>
                  <Dropdown placeholder='Status'
                   fluid search selection onChange={this.status} style={{fontSize: 14}}
                   options={status} value={this.state.status} />
                </Grid.Column>
              </Grid>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <center><div style={{color: 'red', fontSize: 13, fontWeight: 'bold'}}>{this.state.error}</div></center>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <Button fluid style={{display: this.props.partsedit}} positive onClick={this.updateInfo.bind(this)}>
                Save
              </Button>
            </Grid.Column>
          </Grid>
          </Card>
        </div>
    );
    return (
      <div style={{padding: '1%'}}>
        {out}
        {loading}
        {dialogs}
      </div>
    );
  }
}

export default Edit;
